export default __webpack_public_path__ + "static/media/weather.dbf63190.png";